import React from "react";
import { Button } from "@mui/material";
import { Inline } from "components/layout/reusableLayouts";

interface StepFooterProps {
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;
  secondaryLabel?: string;
  onSecondary?: () => void;
}

/** A step's actions in one row on the right, the secondary first, as the app's dialogs and drawers lay them out. */
const StepFooter: React.FC<StepFooterProps> = ({
  primaryLabel,
  onPrimary,
  primaryDisabled,
  primaryLoading,
  secondaryLabel,
  onSecondary,
}) => (
  <Inline
    justify="end"
    gap="var(--space-3)"
    sx={{ marginTop: "var(--space-9)" }}
  >
    {secondaryLabel && onSecondary && (
      <Button variant="default-outlined" type="button" onClick={onSecondary}>
        {secondaryLabel}
      </Button>
    )}
    <Button
      variant="primary-filled"
      type="button"
      onClick={onPrimary}
      disabled={primaryDisabled}
      loading={primaryLoading}
    >
      {primaryLabel}
    </Button>
  </Inline>
);

export default StepFooter;
